<div class="coming-soon-page" [style.grid-column]="'2 / span 10'">
  <app-coming-soon-status
    title="Regions Coming Soon"
    message="We're working on Regions. This feature will be available shortly."
    icon="@tui.globe"
  />
</div>
